/// <amd-module name="Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedArtifactsView" />
import { ArtifactsHeaderBreadcrumbService } from "Build/ArtifactsView/Components/ArtifactsHeaderBreadcrumbService";
import { ArtifactCategory } from "Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedArtifactsResources";
import { ConsumedContainerResourcesCard } from "Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedContainerResourcesCard";
import { ConsumedPipelineResourcesCard } from "Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedPipelineResourcesCard";
import { ConsumedRepositoryResourcesCard } from "Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedRepositoryResourcesCard";
import { ConsumedArtifactsData, ConsumedArtifactSource } from "Build/Client/Contracts/DataProvider";
import { IBuildLinkingService, RouteParameters } from "Build/Client/Linking";
import * as Resources from "Build/ArtifactsView/Resources";
import { NavConstants } from "Build/Common/Library/Constants";
import * as React from "react";
import * as StringUtil from "VSS/Core/Util/String";
import { IVssHistoryService } from "VSS/Platform/History";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";



interface IConsumedArtifactsTabProps extends IVssComponentProperties {
    data: ConsumedArtifactsData;
}

export class ConsumedArtifactsView extends VssComponent<IConsumedArtifactsTabProps> {
    constructor(props: IConsumedArtifactsTabProps) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <div>
                {this._getPipelineResources()}
                {this._getContainerResources()}
                {this._getRepositoryResources()}
            </div>
        );
    }

    public componentDidMount() {
        this._setBreadcrumbs();
    }

    private _getPipelineResources(): JSX.Element {
        const content: JSX.Element[] = (
            this.props.data.consumedSources.filter((consumedArtifactSources: ConsumedArtifactSource) =>
                StringUtil.equals(consumedArtifactSources.artifactCategory, ArtifactCategory.PipelineArtifactCategory, true)).map((consumedPipelineArtifactSource: ConsumedArtifactSource, index: number) => {
                    return <div className="page-content-left page-content-right page-content-top" key={"consumed-pipeline-resources-" + index}>
                        <ConsumedPipelineResourcesCard consumedSource={consumedPipelineArtifactSource} buildId={this.props.data.buildId} />
                    </div>
                })
        );

        return <div className={content && content.length > 0  ? 'card-spacer' : ''}>{...content}</div>;
    }

    private _getContainerResources(): JSX.Element {
        const content: JSX.Element[] = (
            this.props.data.consumedSources.filter((consumedArtifactSources: ConsumedArtifactSource) =>
                StringUtil.equals(consumedArtifactSources.artifactCategory, ArtifactCategory.ContainerArtifactCategory, true)).map((consumedContainerArtifactSource: ConsumedArtifactSource, index: number) => {
                    return <div className="page-content-left page-content-right page-content-top" key={"consumed-container-resources-" + index}>
                        <ConsumedContainerResourcesCard consumedSource={consumedContainerArtifactSource} buildId={this.props.data.buildId} />
                    </div>
                })
        );

        return <div className={content && content.length > 0  ? 'card-spacer' : ''}>{...content}</div>;
    }

    private _getRepositoryResources(): JSX.Element {
        const content: JSX.Element[] = (
            this.props.data.consumedSources.filter((consumedArtifactSources: ConsumedArtifactSource) =>
                StringUtil.equals(consumedArtifactSources.artifactCategory, ArtifactCategory.RepositoryArtifactCategory, true)).map((consumedRepositoryArtifactSource: ConsumedArtifactSource, index: number) => {
                    return <div className="page-content-left page-content-right page-content-top" key={"consumed-repository-resources-" + index}>
                        <ConsumedRepositoryResourcesCard consumedSource={consumedRepositoryArtifactSource} buildId={this.props.data.buildId} />
                    </div>
                })
        );

        return <div className={content && content.length > 0  ? 'card-spacer' : ''}>{...content}</div>;
    }

    private _setBreadcrumbs = (): void => {
        const linkingService = this.context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
        const historyService = this.context.pageContext.getService<IVssHistoryService>("IVssHistoryService");
        const pipelineName: string = this.props.data.definitionName;
        const pipelineUrl: string = linkingService.getDefinitionUrl(this.props.data.definitionId);
        const buildNumber: string = this.props.data.buildNumber;
        const buildUrl: string = linkingService.getBuildUrl(this.props.data.buildId);
        const artifactsView: string = Resources.ConsumedArtifactsText;
        const artifactsViewUrl: string = linkingService.getBuildUrl(this.props.data.buildId, NavConstants.artifacts, undefined, undefined, { [RouteParameters.Type]: historyService.getState()[RouteParameters.Type] });
        const breadcrumbService = this.context.pageContext.getService<ArtifactsHeaderBreadcrumbService>("artifacts-header-breadcrumb-service");
        breadcrumbService.setBreadcrumbs(pipelineName, pipelineUrl, buildNumber, buildUrl, artifactsView, artifactsViewUrl);
    }
}